const HAS_CONNECTED = {
  val: "true",
  label: "True",
};

const HAS_NOT_CONNECTED = {
  val: "false",
  label: "False",
};

const DEVICE_CONNECTED_OPTIONS = [
  { value: HAS_CONNECTED.val, label: HAS_CONNECTED.label },
  { value: HAS_NOT_CONNECTED.val, label: HAS_NOT_CONNECTED.label },
];

export { DEVICE_CONNECTED_OPTIONS };
